import React from 'react';
import logoIcon from '../../images/site_logo/buildlab_icon.png';
import './BuildLabWorkflow.css';

const STAKEHOLDERS = [
    { title: 'Owner', sub: 'Sponsor / Developer' },
    { title: 'Project Consultant', sub: 'Strategy & coordination' },
    { title: 'Architect / Designer', sub: 'Plans & CDs' },
    { title: 'Principal Contractor', sub: 'Build & subs' },
];

const REVENUE_SERVICES = [
    'ISP Right of Entry (ROE) negotiation',
    'Life & Safety Lines coordination',
    'TCAC broadband score support',
    'CASF / CPUC grant management',
    'Milestone media (photo · video · drone)',
];

const BUILD_SERVICES = [
    'Low-Voltage & structured cabling',
    'Door access control systems',
    'Surveillance & life safety',
    'Computer networks · WiFi · broadband',
    'Common-area & ops technology (lab, EV, AV)',
];

const LIFECYCLE = [
    { n: '01', title: 'Pre-Construction', sub: 'Negotiate ISP · scope tech' },
    { n: '02', title: 'Construction', sub: 'Coordinate Div 27 & 28' },
    { n: '03', title: 'Operations Handoff', sub: 'PM training · documentation' },
    { n: '04', title: 'Marketing & Media', sub: 'Drone · photo · lease-up assets' },
];

const BuildLabWorkflow = () => {
    return (
        <div className="blw">
            <div className="blw-tier-wrap">
                <div className="blw-tier-label">Project Stakeholders</div>
            </div>
            <div className="blw-row">
                {STAKEHOLDERS.map((s, i) => (
                    <div className="blw-stake-card" key={i}>
                        <div className="blw-title">{s.title}</div>
                        <div className="blw-sub">{s.sub}</div>
                    </div>
                ))}
            </div>

            <div className="blw-connect"></div>

            <div className="blw-hub">
                <div className="blw-hub-inner">
                    <img src={logoIcon} alt="BUILDLAB" className="blw-hub-logo" />
                </div>
            </div>

            <div className="blw-connect"></div>

            <div className="blw-tier-wrap">
                <div className="blw-tier-label">Services BUILDLAB Designs &amp; Coordinates</div>
            </div>
            <div className="blw-services-grid">
                <div className="blw-svc-col accent-info">
                    <h4>Revenue &amp; Compliance</h4>
                    <ul className="blw-svc-list">
                        {REVENUE_SERVICES.map((s, i) => <li key={i}>{s}</li>)}
                    </ul>
                </div>
                <div className="blw-svc-col">
                    <h4>Building Technology</h4>
                    <ul className="blw-svc-list">
                        {BUILD_SERVICES.map((s, i) => <li key={i}>{s}</li>)}
                    </ul>
                </div>
            </div>

            <div className="blw-connect"></div>

            <div className="blw-tier-wrap">
                <div className="blw-tier-label">Project Lifecycle</div>
            </div>
            <div className="blw-lifecycle">
                {LIFECYCLE.map((s, i) => (
                    <div className="blw-step" key={i}>
                        <div className="blw-step-n">{s.n}</div>
                        <div className="blw-step-title">{s.title}</div>
                        <div className="blw-step-sub">{s.sub}</div>
                    </div>
                ))}
            </div>

            <div className="blw-connect"></div>

            <div className="blw-outcome">
                <span className="blw-outcome-sub">Delivered to you</span>
                Configuration · Testing · Documentation · Training
            </div>
        </div>
    );
};

export default BuildLabWorkflow;
